import Vip from './template_01';

const DefaultVip=(props) =>{
    return (
        <Vip {...props}/>
    );
  }
  
  export default DefaultVip;